import { render } from "./hidden.vue?vue&type=template&id=58667504"
import script from "./hidden.vue?vue&type=script&lang=js"
export * from "./hidden.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/form-sections/hidden.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58667504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58667504', __exports__)) {
    console.log('reload')
    api.reload('58667504', __exports__)
  }
  
  module.hot.accept("./hidden.vue?vue&type=template&id=58667504", () => {
    console.log('re-render')
    api.rerender('58667504', render)
  })

}


export default __exports__